<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let award = data?.award;
	let faq = data?.faq;

	onMount(() => {
		initHeroHomeSwiper();
		
		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>FAQ - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="http://50.6.171.246:5000/contact" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="contact">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img alt="Holiday Inn Resorts Nusa Dua" src="/img/bg-header-faq.webp" class="img-header" />
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100 z-3">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Dining</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container py-md-5 py-3 mt-md-4">
		<div class="row g-0">
			<div class="col-md-12 mb-md-4 mb-3 px-md-4 text-center">
				<p class="mb-md-3 mb-2 main-color fs-1 ff-lola-bir">{$_('faq_title')}</p>
				<p class="line mb-3 mx-auto"></p>
			</div>
			<div class="col-md-12">
				{#each faq as faq, index}
					<div class="accordion mb-3 ff-helvetica" id="accordion-{index}">
						<div class="accordion-item">
							<h2 class="accordion-header">
								<button
									class="accordion-button collapsed"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target="#collapse-{index}"
									aria-expanded="false"
									aria-controls="collapse-{index}"
								>
									{faq.question}
								</button>
							</h2>
							<div
								id="collapse-{index}"
								class="accordion-collapse collapse"
								data-bs-parent="#accordion-{index}"
							>
								<div class="accordion-body">
									{@html faq.answer}
								</div>
							</div>
						</div>
					</div>
				{/each}
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.line {
		border-bottom: 2px solid #451C70;
		width: 25%;
	}
</style>
